// Shared "does the chip-label pill fit?" helper for TTS Timeline +
// STS MasterTimeline. Both render their chips with a tinted pill behind
// the label text (.chipLabel — padding: 2px 6px = 12px horizontal, font:
// inherits 500 10px Poppins from .chip). When the chip narrows past the
// pill's natural width (e.g. fully-zoomed-out long timelines) the label
// is hidden entirely so we don't get a sea of clipped digits drowning
// out the chip background.
//
// Measurement uses one shared offscreen canvas — lazy-init on first call
// so SSR / pre-DOM imports don't crash. Canvas measureText is exact and
// avoids the layout thrash + double-render of measuring a real DOM span.

const LABEL_FONT = '500 10px Poppins, sans-serif';
/** .chipLabel CSS — padding: 2px 6px → 12px horizontal padding. */
const LABEL_PILL_PADDING_PX = 12;
/** Breathing room so the pill doesn't kiss the chip's outer edges. */
const LABEL_PILL_BUFFER_PX = 4;

let measureCtx: CanvasRenderingContext2D | null = null;
function getCtx(): CanvasRenderingContext2D | null {
  if (measureCtx) return measureCtx;
  if (typeof document === 'undefined') return null;
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  ctx.font = LABEL_FONT;
  measureCtx = ctx;
  return ctx;
}

/** True when the rendered label-pill (text + horizontal padding +
 *  breathing buffer) fits within `chipWidthPx`. Caller hides the label
 *  when this returns false. Fails open (returns true) if canvas isn't
 *  available — safer to over-render than over-hide. */
export function chipLabelFits(label: string, chipWidthPx: number): boolean {
  const ctx = getCtx();
  if (!ctx) return true;
  const textWidth = ctx.measureText(label).width;
  return chipWidthPx >= textWidth + LABEL_PILL_PADDING_PX + LABEL_PILL_BUFFER_PX;
}
